import req from './http.js'

// 沒有reservation的reservation api模組:P

// 登入
export const apiLogin = params => req('post', '/reservation/adminManage/adminLogin', params)

// 查詢課程
export const apiGetTicketProjectList = params => req('post','/reservation/adminManage/getTicketProjectList', params)

// 用關鍵字搜尋店家
export const apiGetMerchantAutoComplete = params => req('post','/reservation/adminManage/getMerchantAutoComplete', params)

// 取得店家
export const apiGetMerchantList = params => req('post','/reservation/adminManage/getMerchantList', params)

// 登出API
export const apiLogout = params => req('post','/reservation/adminManage/adminLogout', params)

// 設定課程分店資料
export const apiSearchStoreList = params => req('post', '/reservation/adminManage/searchStoreList', params)

// 更新課程設定
export const apiSetupMerchantTicket = params => req('post', '/reservation/adminManage/setupMerchantTicket', params)

// 添加課程的使用店家
export const apiSetupProdStoreRel = params => req('post', '/reservation/adminManage/setupProdStoreRel', params)

// 用供應商id取得供應商資料
export const apiGetMerchantById = params => req('post', '/reservation/adminManage/getMerchantById', params)

// 更新供應商資料
export const apiUpdateMerchant = params => req('post', '/reservation/adminManage/updateMerchant', params)

// 新建店家
export const apiCreateStore = params => req('post', '/reservation/adminManage/createStore', params)

// 更新店家資料
export const apiUpdateStore = params => req('post', '/reservation/adminManage/updateStore', params)

// 取消票的核銷
export const apiCancelServiceExecution = params => req('post', '/reservation/adminManage/cancelServiceExecution', params)

// 更新請款單
export const apiUpdatePaymentRequestStatus = params => req('post','/reservation/adminManage/updatePaymentRequestStatus', params)

// 檢查票是否存在
export const apiCheckScannedPaperTicket = params => req('post', '/reservation/adminManage/checkScannedPaperTicket', params)

// 建立紙本票請款單
export const apiCreatePaperPaymentForm = params => req('post','/reservation/adminManage/createPaperPaymentForm', params)

// 更新資料
export const apiUpdateSelfProfile = params => req('post', '/reservation/adminManage/updateSelfProfile', params)

// 更新為已下載
export const apiUpdatePaymentRequestDownloadedMultiple = params => req('post', '/reservation/adminManage/updatePaymentRequestDownloadedMultiple', params)

// 同步更新資料
export const apiForceSyncNow = params => req('post', '/reservation/adminManage/forceSyncNow', params)

// 建立藍新商品
export const apiCreateNWProduct = params => req('post', '/reservation/adminManage/createNWProduct', params)

// 更新藍新商品
export const apiUpdateNWProduct = params => req('post', '/reservation/adminManage/updateNWProduct', params)

// 取得尚未信託的金額
export const apiGetTicketRemainBalance = params => req('post', '/reservation/adminManage/getTicketRemainBalance', params)

// 用id取得store name
export const apiGetStoreById = params => req('post', '/reservation/adminManage/getStoreById', params)

// 重設店家密碼
export const apiUpdateStoreManageAccount = params => req(
    'post',
    '/reservation/adminManage/updateStoreManageAccount',
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})
